(function () {
  'use strict';

  function init() {
    const placeholders = document.querySelectorAll('[data-jb-yt-player]');
    if (!placeholders.length) return;

    if (window.YT && window.YT.Player) {
      bootAll(placeholders);
      return;
    }

    const previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousReady === 'function') previousReady();
      bootAll(placeholders);
    };

    if (!document.querySelector('script[data-jb-yt-api]')) {
      const s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      s.setAttribute('data-jb-yt-api', '');
      document.head.appendChild(s);
    }
  }

  function bootAll(placeholders) {
    placeholders.forEach(boot);
  }

  function fmt(seconds) {
    const s = Math.max(0, Math.floor(seconds || 0));
    const m = Math.floor(s / 60);
    return m + ':' + String(s % 60).padStart(2, '0');
  }

  function boot(el) {
    const id = el.id;
    if (!id) return;

    const loop = el.dataset.loop === 'true';
    const coverDelayMs = parseInt(el.dataset.coverDelay, 10) || 5000;

    const wrapper = el.closest('.jb-multi-block__video-wrapper, .jb-multi-block__text-video-wrapper');
    const cover = wrapper
      ? (wrapper.querySelector('.jb-multi-block__cover-image') || wrapper.querySelector('.jb-multi-block__text-video-cover'))
      : null;
    const controls = document.querySelector('[data-jb-yt-controls-for="' + CSS.escape(id) + '"]');

    let player;
    let isSeeking = false;
    let timeTimer = null;
    let coverHideScheduled = false;

    const playBtn = controls ? controls.querySelector('[data-jb-yt-action="play"]') : null;
    const muteBtn = controls ? controls.querySelector('[data-jb-yt-action="mute"]') : null;
    const scrubber = controls ? controls.querySelector('[data-jb-yt-action="seek"]') : null;
    const timeEl = controls ? controls.querySelector('[data-jb-yt-time]') : null;

    function updateMutedClass() {
      if (!controls || !player || !player.isMuted) return;
      controls.classList.toggle('is-muted', player.isMuted());
    }

    function startTimer() {
      stopTimer();
      timeTimer = setInterval(() => {
        if (!player || isSeeking) return;
        const cur = player.getCurrentTime ? player.getCurrentTime() : 0;
        const dur = player.getDuration ? player.getDuration() : 0;
        if (scrubber && dur > 0) scrubber.value = (cur / dur) * 100;
        if (timeEl) timeEl.textContent = fmt(cur) + ' / ' + fmt(dur);
      }, 250);
    }

    function stopTimer() {
      if (timeTimer) {
        clearInterval(timeTimer);
        timeTimer = null;
      }
    }

    player = new YT.Player(id, {
      events: {
        onReady: function (e) {
          updateMutedClass();
          if (timeEl) {
            const dur = e.target.getDuration ? e.target.getDuration() : 0;
            timeEl.textContent = '0:00 / ' + fmt(dur);
          }
        },
        onStateChange: function (e) {
          const PS = window.YT.PlayerState;
          if (e.data === PS.PLAYING) {
            controls && controls.classList.add('is-playing');
            if (cover && !coverHideScheduled) {
              coverHideScheduled = true;
              setTimeout(() => cover.classList.add('is-hidden'), coverDelayMs);
            }
            startTimer();
          } else {
            controls && controls.classList.remove('is-playing');
            if (e.data !== PS.BUFFERING) stopTimer();
          }
          if (e.data === PS.ENDED) {
            if (loop) {
              e.target.seekTo(0);
              e.target.playVideo();
            } else if (scrubber) {
              scrubber.value = 0;
            }
          }
        }
      }
    });

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (!player || !player.getPlayerState) return;
        const PS = window.YT.PlayerState;
        const state = player.getPlayerState();
        if (state === PS.PLAYING) {
          player.pauseVideo();
        } else {
          player.playVideo();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        if (!player || !player.isMuted) return;
        if (player.isMuted()) {
          player.unMute();
          if (player.getVolume && player.getVolume() === 0) player.setVolume(100);
        } else {
          player.mute();
        }
        updateMutedClass();
      });
    }

    if (scrubber) {
      scrubber.addEventListener('input', () => {
        isSeeking = true;
        if (!player || !player.getDuration) return;
        const dur = player.getDuration();
        if (dur > 0) {
          const t = (parseFloat(scrubber.value) / 100) * dur;
          player.seekTo(t, true);
          if (timeEl) timeEl.textContent = fmt(t) + ' / ' + fmt(dur);
        }
      });
      scrubber.addEventListener('change', () => {
        setTimeout(() => { isSeeking = false; }, 200);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
